const DeviceSize = {
    mobile: 780,
    tablet: 992,
    laptop: 1324,
    desktop: 2024,
};

export default DeviceSize;